module.exports = __webpack_public_path__ + "img/inperson.560ffa05.svg";